module.exports = __webpack_public_path__ + "static/media/img1-3.b50a6309.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/nogal/nutricheck_foliar/B/img1-3.png
// module id = 1905
// module chunks = 3